import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-submit-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './submit-grid.component.html',
  styleUrl: './submit-grid.component.scss'
})
export class SubmitGridComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  currentRoute = signal<string>('');
  
  skipButtonRoutes = signal<string[]>([
    'manage-account/create-video-template/:company/:site'
  ]);

  // Store route parameters
  routeParams = signal<{company?: string; site?: string}>({});

  ngOnInit() {
    // Subscribe to route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentRoute.set(event.url);
      this.updateRouteParams();
    });

    // Subscribe to route parameter changes
    this.activatedRoute.params.subscribe(params => {
      this.routeParams.set(params);
    });

    // Set initial values
    this.currentRoute.set(this.router.url);
    this.updateRouteParams();
  }

  // Extract parameters from current route
  updateRouteParams() {
    const segments = this.currentRoute().split('/').filter(segment => segment);
    
    // Try to match against your route patterns
    if (segments.length >= 4 && segments[0] === 'manage-account') {
      const action = segments[1];
      const company = segments[2];
      const site = segments[3];
      
      if (action === 'create-video-template') {
        this.routeParams.set({ company, site });
      }
    }
  }

  // Method to check if skip button should be shown
  shouldShowSkipButton(): boolean {
    const route = this.currentRoute();
    const segments = route.split('/').filter(segment => segment);
    
    // Check if current route matches any skip button route pattern
    return this.skipButtonRoutes().some(skipRoute => {
      const skipSegments = skipRoute.split('/').filter(segment => segment);
      
      // Both routes should have same segment count
      if (segments.length !== skipSegments.length) return false;
      
      // Compare each segment
      for (let i = 0; i < segments.length; i++) {
        // If skip segment starts with ':', it's a parameter - accept any value
        if (skipSegments[i].startsWith(':')) continue;
        
        // Otherwise, segments must match exactly
        if (segments[i] !== skipSegments[i]) return false;
      }
      
      return true;
    });
  }

  onSkip() {
    const params = this.routeParams();
    const currentRoute = this.currentRoute();
    
    if (currentRoute.includes('/create-video-template/')) {
      // Navigate to next step after video template
      if (params.company && params.site) {
        this.router.navigate([
          'manage-account', 
          'create-pricing-plan', 
          params.company
        ]);
      }
    }
  }

}
